import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

const themes = {
  default: 'default',
  checkmarks: 'theme-checkmarks',
  fancyBullets: 'theme-fancy-bullets',
  centered: 'theme-centered',
  white: 'theme-white'
};

const RichText = ({ className, element, text, theme }) =>
  React.createElement(element, {
    className: cn('rich-text', className, theme),
    dangerouslySetInnerHTML: { __html: text }
  });

RichText.propTypes = {
  className: PropTypes.string,
  element: PropTypes.string,
  text: PropTypes.string,
  theme: PropTypes.oneOf(Object.values(themes))
};

RichText.propTypesMeta = {
  className: 'exclude',
  element: 'exclude',
  theme: 'exclude'
};

RichText.defaultProps = {
  element: 'div'
};

RichText.themes = themes;

export default RichText;
